import { AttachmentFragment } from '@spotify/confidence-graphql';
import { formatRuleId } from '@spotify/plugin-confidence-flags-react';

export const useResolvedRuleName = (
  artifact: AttachmentFragment,
): string | undefined => formatRuleId(artifact.uri) || undefined;
